// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"9":"Contact","304":"Suit","787":"Suits"}[chunkId] || chunkId) + "." + {"9":"b276bf86","90":"dd6fdee9","280":"2270ec77","304":"3c314fd1","358":"a9d6ef92","594":"25dfe81d","787":"62adf752","830":"683fedff","895":"ca6c2fd8","957":"683fedff","995":"24701436"}[chunkId] + ".css";
};